module.exports = __webpack_public_path__ + "static/media/Suli-Compound-mobile.664c0be0.webp";